import { render, staticRenderFns } from "./trafficManage.vue?vue&type=template&id=735ffcb2&scoped=true&"
import script from "./trafficManage.vue?vue&type=script&lang=js&"
export * from "./trafficManage.vue?vue&type=script&lang=js&"
import style0 from "./trafficManage.vue?vue&type=style&index=0&id=735ffcb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ffcb2",
  null
  
)

export default component.exports